import { createEntityAdapter } from '@reduxjs/toolkit';
import { Message } from '../../../types/message';
import { sortDatetimeIncrease } from '../../../utils/dates_comparer';

export const messagesAdapter = createEntityAdapter<Message>({
  sortComparer: (messageA, messageB) => sortDatetimeIncrease(messageA.sentAt, messageB.sentAt),
});
export const messagesInitialState = messagesAdapter.getInitialState();
